/**
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Jérôme Poulalier.
 *
 * Jérôme Poulalier can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Dispatcher.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

/**
 * Event dispatcher singleton.
 */
class Dispatcher {
    commit (eventType, detail) {
        const event = new window.CustomEvent(eventType, {detail})
        window.dispatchEvent(event)
    }
}

/**
 * @ignore
 */
export default new Dispatcher()



// WEBPACK FOOTER //
// ./webpack/js/utils/Dispatcher.js